import React, { FC } from 'react';
import { SnackbarProviderProps, useSnackbar } from 'notistack';
import {
  SuccessIcon,
  InfoIcon,
  WarningIcon,
  ErrorIcon,
  CloseIcon,
} from './styles';
import { CloseSnackbarProps } from './types';

const Action: FC<CloseSnackbarProps> = ({ key }) => {
  const { closeSnackbar } = useSnackbar();
  return (
    <CloseIcon
      onClick={() => {
        closeSnackbar(key);
      }}
    />
  );
};

const notistackConfig: Partial<SnackbarProviderProps> = {
  maxSnack: 2,
  action: Action,
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
  classes: {
    variantSuccess: 'cd-snackbar-success',
    variantWarning: 'cd-snackbar-warning',
    variantError: 'cd-snackbar-error',
    variantInfo: 'cd-snackbar-info',
  },
  iconVariant: {
    success: <SuccessIcon />,
    info: <InfoIcon />,
    warning: <WarningIcon />,
    error: <ErrorIcon />,
  },
};

export default notistackConfig;
